export { default } from './error-layout';
export { default as styles } from './error-layout.styles';
